navApp.directive('navcollection', [
  'templatePath', 'endpointDomain', 'NavStateService', 'updateHeight', function(templatePath, endpointDomain, NavStateService, updateHeight) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        collection: '='
      },
      templateUrl: 'navcollection.html',
      controller: [
        '$scope', function($scope) {
          return $scope.navStateService = NavStateService;
        }
      ],
      link: function(scope, element, attrs) {
        scope.navkey = attrs['navkey'];
        scope.navlevel = attrs['navlevel'];
        return scope.updateCallout = function() {
          if (scope.navStateService.hasCallout(scope.$parent.item)) {
            NavStateService.updateCallout(scope.navkey, scope.$parent.item);
            return updateHeight(element);
          }
        };
      }
    };
  }
]);
